const initializeCategoryVideos = (root = document) => {
    const videos = root.querySelectorAll('[data-category-video]');

    if (!videos.length) return;

    const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

    if (reducedMotion) {
        videos.forEach((video) => {
            video.pause();
            video.removeAttribute('autoplay');
        });
        return;
    }

    const play = (video) => {
        const promise = video.play();

        if (promise && typeof promise.catch === 'function') {
            promise.catch(() => {});
        }
    };

    if (!('IntersectionObserver' in window)) {
        videos.forEach(play);
        return;
    }

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    play(entry.target);
                } else {
                    entry.target.pause();
                }
            });
        },
        { rootMargin: '160px 0px', threshold: 0.15 },
    );

    videos.forEach((video) => observer.observe(video));

    window.addEventListener('pagehide', () => observer.disconnect(), { once: true });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeCategoryVideos());
} else {
    initializeCategoryVideos();
}
